module.exports = __webpack_public_path__ + "img/tabs2.02206f73.png";